import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Divider from '@material-ui/core/Divider';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import { GlobalContext } from '../../Context/Global.context';
// import GetMoreButton from '../../Util/GetMoreButton';
import ProgressIndicator from '../../Components/ProgressIndicator';
import {
  GetUserValue,
} from '../../Util/Properties';

import API from '../../Util/api';
import debounce from 'es6-promise-debounce';
import { IsMobile } from '../../Util/MobileDetector';

import {
  GetProjectMemberPathForApi,
  GetProjectGroupsPathForApi,
  GetProjectGroupMembersPathForApi,
} from '../../Util/api';

const styles = theme => ({
  dialogPaper: {
    height:(!IsMobile()) ? "80%" : undefined,
  },
  dialogTitle: {
  },
  dialogContent: {
  },
  dialogActions: {
  },
  contentContainer: {
    marginTop:theme.spacing(2),
    "& .MuiListItem-gutters": {
      paddingLeft: 0,
    },
  },
  groupsList: {
    maxHeight: '300px',
    overflow: 'auto',
  },
});

class ProjectMemberDialog extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    this.state = {
      open: props.open,
      ProjectMember: props.ProjectMember,
      ShowProgressIndicator: false,
      projectGroups: [],
      memberGroupAssignments: [], // List of groups this member belongs to
    }
  }

  handleClose = () => {
    this.setState({
      open: false,
    });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleUpdateProjectMemberBoolean(id, boolean) {
    let projectMember = {...this.state.ProjectMember};
    projectMember[id] = boolean;
    this.updateProjectMember(projectMember);
  }

  updateProjectMember = ProjectMember => {
    this.setState({ProjectMember});
    this.handleUpdateServerProjectMember(ProjectMember);
    if (ProjectMember && this.props.onProjectMemberRevised) {
      this.props.onProjectMemberRevised({...ProjectMember});
    }
  }

  handleUpdateServerProjectMember = debounce(projectMember => {
    if (!this.props.ProjectMember) {
      return;
    }
    if (!projectMember) {
      projectMember = {...this.state.ProjectMember};
    }

    API.put(GetProjectMemberPathForApi(projectMember.OrganizationID, projectMember.ProjectID,
      projectMember.ID), projectMember)
      .then(resp => {
        this.setState({
          // ProjectMember: resp.data,
        });
      })
      .catch(this.handleApiError);
  }, 250);

  isCurrentUserSameAsProjectMember() {
    return this.state.ProjectMember.UserEmail === this.context.UserPreferences.UserEmail;
  }

  canUpdateIsDisabled() {
    if (
      // Current user is the same as the member
      this.isCurrentUserSameAsProjectMember()
      // Member is an org admin
      || this.state.ProjectMember.OrganizationMemberIsAdmin
      // Member is an admin
      || this.state.ProjectMember.IsAdmin
    ) { return false; }
    return true;
  }

  canUpdateIsAdmin() {
    if (
      // Current user is the same as the member
      this.isCurrentUserSameAsProjectMember()
      // Member is an org admin
      || this.state.ProjectMember.OrganizationMemberIsAdmin
      // Member is disabled
      || this.state.ProjectMember.Disabled
      // Member is read-only
      || this.state.ProjectMember.IsReadOnly
    ) { return false; }
    return true;
  }

  canUpdateIsReadOnly() {
    if (
      // Current user is the same as the member
      this.isCurrentUserSameAsProjectMember()
      // Member is an org admin
      || this.state.ProjectMember.OrganizationMemberIsAdmin
      // Member is disabled
      || this.state.ProjectMember.Disabled
      // Member is an admin
      || this.state.ProjectMember.IsAdmin
    ) { return false; }
    return true;
  }

  // Load all project groups
  loadProjectGroups = () => {
    const { ProjectMember } = this.state;
    if (!ProjectMember) return;
    
    this.setState({ ShowProgressIndicator: true });
    API.get(GetProjectGroupsPathForApi(ProjectMember.OrganizationID, ProjectMember.ProjectID), 
      { params: { getAll: true } })
      .then(resp => {
        this.setState({
          projectGroups: resp.data.ProjectGroups || [],
          ShowProgressIndicator: false,
        });
        
        // After loading project groups, load the member's group assignments for each group
        this.loadMemberGroupAssignments();
      })
      .catch(this.handleApiError);
  }

  // Load the member's group assignments
  loadMemberGroupAssignments = () => {
    const { ProjectMember, projectGroups } = this.state;
    if (!ProjectMember || !projectGroups.length) return;
    
    this.setState({ ShowProgressIndicator: true });
    
    // Create an array to store all group memberships
    const memberGroupAssignments = [];
    
    // Create an array of promises for each group check
    const promises = projectGroups.map(group => {
      return API.get(GetProjectGroupMembersPathForApi(ProjectMember.OrganizationID, ProjectMember.ProjectID, group.ID), 
        { params: { getAll: true } })
        .then(resp => {
          const groupMembers = resp.data.ProjectGroupMembers || [];
          // Check if this member is in this group
          const isMemberInGroup = groupMembers.some(m => m.ProjectMemberID === ProjectMember.ID);
          
          if (isMemberInGroup) {
            // Store the group membership with the group ID and the membership details
            const memberGroupAssignment = groupMembers.find(m => m.ProjectMemberID === ProjectMember.ID);
            memberGroupAssignments.push({
              groupID: group.ID,
              membershipDetails: memberGroupAssignment
            });
          }
        })
        .catch(this.handleApiError);
    });
    
    // Wait for all checks to complete
    Promise.all(promises)
      .then(() => {
        this.setState({
          memberGroupAssignments,
          ShowProgressIndicator: false
        });
      })
      .catch(this.handleApiError);
  }

  // Toggle group membership for this member
  handleToggleGroup = (groupId) => {
    const { ProjectMember, memberGroupAssignments } = this.state;
    
    // Check if member is already in the group
    const groupAssignment = memberGroupAssignments.find(assignment => assignment.groupID === groupId);
    const isMemberInGroup = Boolean(groupAssignment);
    
    if (isMemberInGroup) {
      // Remove member from group
      this.setState({ ShowProgressIndicator: true });
      API.delete(GetProjectGroupMembersPathForApi(ProjectMember.OrganizationID, ProjectMember.ProjectID, groupId), 
        { data: { IDs: [groupAssignment.membershipDetails.ID] } })
        .then(() => {
          // Update the list of group memberships
          this.loadMemberGroupAssignments();
        })
        .catch(this.handleApiError);
    } else {
      // Add member to group
      this.setState({ ShowProgressIndicator: true });
      API.post(GetProjectGroupMembersPathForApi(ProjectMember.OrganizationID, ProjectMember.ProjectID, groupId), 
        [{ ProjectMemberID: ProjectMember.ID }])
        .then(() => {
          // Update the list of group memberships
          this.loadMemberGroupAssignments();
        })
        .catch(this.handleApiError);
    }
  }

  handleApiError = err => {
    this.setState({ShowProgressIndicator: false});
    this.props.onApiError(err);
  }

  componentDidMount() {
    console.log("componentDidMount", this.state.ProjectMember);
    if (this.state.ProjectMember) {
      this.loadProjectGroups();
    }
  }

  componentDidUpdate(prevProps) {
    if (typeof this.props.open !== "undefined"
      && prevProps.open !== this.props.open) {
      let stateToUpdate = {
        open: this.props.open !== false,
      }
      if (this.props.open) {
        if (this.props.ProjectMember) {
          stateToUpdate.ProjectMember = this.props.ProjectMember;
          
          // Load groups when dialog opens with a project member
          this.setState(stateToUpdate, () => {
            this.loadProjectGroups();
          });
          return;
        } else {
          stateToUpdate.ProjectMember = null;
        }
      } else {
        stateToUpdate.ProjectMember = null;
      }
      this.setState(stateToUpdate);
    }
  }

  render() {
    const {
      open,
      ProjectMember,
      ShowProgressIndicator,
      projectGroups,
      memberGroupAssignments,
    } = this.state;
    const {
      classes,
      theme,
      showProgressIndicatorImmediately,
    } = this.props;
    const {
      CompletedGET,
    } = this.context;

    if (!CompletedGET.UserPreferences) {
      return null;
    }

    const dialogActions = (
      <DialogActions className={classes.dialogActions}>
        <Button onClick={() => this.handleClose()}>
          CLOSE
        </Button>
      </DialogActions>
    );

    const progressIndicator = (ShowProgressIndicator || showProgressIndicatorImmediately)
      ? (
        <ProgressIndicator showImmediately={showProgressIndicatorImmediately} />
      )
      : null;

    const content = ProjectMember ? (
      <React.Fragment>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <FormControlLabel
              control={
                <Switch
                  color="secondary"
                  checked={ProjectMember.Disabled || false}
                  disabled={!this.canUpdateIsDisabled()}
                  onClick={e => e.stopPropagation()}
                  onChange={e => this.handleUpdateProjectMemberBoolean("Disabled", e.target.checked)}
                />
              }
              label="Disabled" />
          </Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Switch
                  color="secondary"
                  checked={ProjectMember.IsAdmin || false}
                  disabled={!this.canUpdateIsAdmin()}
                  onClick={e => e.stopPropagation()}
                  onChange={e => this.handleUpdateProjectMemberBoolean("IsAdmin", e.target.checked)} 
                />
              }
              label={"Project Manager"} />
          </Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Switch
                  color="secondary"
                  checked={ProjectMember.IsStakeholder || false}
                  onClick={e => e.stopPropagation()}
                  onChange={e => this.handleUpdateProjectMemberBoolean("IsStakeholder", e.target.checked)} 
                />
              }
              label={"Stakeholder"} />
          </Grid>

          <Grid item>
            <Divider />
          </Grid>
          
          <Grid item style={{marginLeft:theme.spacing(1),marginRight:theme.spacing(1)}}>
            <Grid container>
              <Grid item xs={6}>
                <Typography variant="subtitle2">Group</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" align="right">Member In Group</Typography>
              </Grid>
            </Grid>
            <List className={classes.groupsList}>
              {projectGroups.map(group => {
                const isInGroup = memberGroupAssignments.some(assignment => assignment.groupID === group.ID);
                return (
                  <ListItem key={group.ID}>
                    <ListItemText primary={group.Name} />
                    <ListItemSecondaryAction>
                      <Switch
                        checked={isInGroup}
                        onChange={() => this.handleToggleGroup(group.ID)}
                        color="primary"
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          </Grid>
        </Grid>
      </React.Fragment>
    ) : null;

    return (
      <Dialog
        fullScreen={IsMobile()}
        fullWidth={!IsMobile()}
        maxWidth="sm"
        open={open}
        classes={{
          paper:classes.dialogPaper,
        }}
        onClose={() => this.handleClose()}
      >
        <DialogTitle id="dialog-title" className={classes.dialogTitle}>
          Project Member Details
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {GetUserValue(ProjectMember?.UserEmail, ProjectMember?.UserName, "profile")}
          
          {progressIndicator}
          
          <div className={classes.contentContainer}>
            {content}
          </div>

        </DialogContent>
        {dialogActions}
      </Dialog>
    );
  }
}

ProjectMemberDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  ProjectMember: PropTypes.object,
  onClose: PropTypes.func,
  onApiError: PropTypes.func.isRequired,
  onProjectMemberRevised: PropTypes.func,
};

export default withStyles(styles, {withTheme: true})(ProjectMemberDialog);